import { HTMLAttributes } from "react";
import Icon from "../image/Icon";

export const IcBtn: React.FC<
  HTMLAttributes<HTMLButtonElement> & {
    ic: string;
    vari?: "BASE" | "SM";
  }
> = (jj) => {
  const { ic, vari, ...props } = jj;
  if (vari === "SM") {
    return <IcBtnSm {...jj} />;
  }
  return (
    <button
      type="button"
      className="flex size-10 items-center justify-center"
      {...props}
    >
      <Icon src={ic} />
    </button>
  );
};

export const IcBtnSm: React.FC<
  HTMLAttributes<HTMLButtonElement> & {
    ic: string;
  }
> = ({ ic, ...props }) => (
  <button
    type="button"
    className="flex size-6 items-center justify-center"
    {...props}
  >
    <Icon className="size-6" src={ic} />
  </button>
);
